// home-type-tester.js — Homepage fit-to-width type tester with font selector.
// Text always scales to fill the stage width. Axes rebuild when font changes.

(function () {
  'use strict';

  var section = document.querySelector('[data-home-tester]');
  if (!section) return;

  // ---- Load font configs from embedded JSON ----
  var configEl = document.getElementById('home-tester-configs');
  var CONFIGS;
  try {
    CONFIGS = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('home-type-tester: invalid config JSON', e);
    return;
  }

  var DEFAULT_FONT = 'Gluten';
  var PLACEHOLDER  = 'open source';
  var REF_SIZE     = 200; // px — reference size used for text width measurement

  var fontSelect = section.querySelector('[data-ht-font-select]');
  var axesEl     = section.querySelector('[data-ht-axes]');
  var caseBtn    = section.querySelector('[data-ht-case]');
  var textEl     = section.querySelector('[data-ht-text]');
  var stage      = section.querySelector('[data-ht-stage]');
  var measurer   = section.querySelector('[data-ht-measurer]');

  var state = {
    font:      DEFAULT_FONT,
    axes:      {},
    uppercase: false
  };

  // ---- Axis sliders ----

  function buildAxes(fontName) {
    axesEl.innerHTML = '';
    var config = CONFIGS[fontName];
    if (!config) return;

    state.axes = Object.assign({}, config.defaultAxes);

    Object.keys(config.axes).forEach(function (key) {
      var ax     = config.axes[key];
      var defVal = config.defaultAxes[key] !== undefined ? config.defaultAxes[key] : ax.min;
      var step   = parseFloat(ax.step || 1);

      var group = document.createElement('div');
      group.className = 'tester-control home-tester__axis';

      var label = document.createElement('label');
      label.className = 'tester-control__label';
      label.appendChild(document.createTextNode(ax.label || key));

      var valueSpan = document.createElement('span');
      valueSpan.setAttribute('data-axis-value', '');
      valueSpan.textContent = step >= 1 ? Math.round(defVal) : parseFloat(defVal).toFixed(2);
      label.appendChild(valueSpan);

      var input = document.createElement('input');
      input.type = 'range';
      input.min   = ax.min;
      input.max   = ax.max;
      input.step  = ax.step || 1;
      input.value = defVal;
      input.setAttribute('aria-label', ax.label || key);

      input.addEventListener('input', function () {
        state.axes[key] = parseFloat(input.value);
        valueSpan.textContent = step >= 1 ? Math.round(input.value) : parseFloat(input.value).toFixed(2);
        render();
      });

      group.appendChild(label);
      group.appendChild(input);
      axesEl.appendChild(group);
    });
  }

  // ---- Font variation settings string ----

  function buildFVS() {
    var config = CONFIGS[state.font];
    return Object.keys(config.defaultAxes).map(function (axis) {
      var val = state.axes[axis] !== undefined ? state.axes[axis] : config.defaultAxes[axis];
      return '"' + axis + '" ' + val;
    }).join(', ');
  }

  // ---- Fit to width ----
  // Renders text into an off-screen measurer span at REF_SIZE, then scales
  // the font size so the text exactly fills the stage width.

  function fitText() {
    var text = state.uppercase ? getText().toUpperCase() : getText();
    if (!text) return;

    // Use the content width (excluding horizontal padding) so the text
    // doesn't overflow the stage edges and get clipped.
    var stageStyle     = window.getComputedStyle(stage);
    var containerWidth = stage.offsetWidth
      - parseFloat(stageStyle.paddingLeft  || 0)
      - parseFloat(stageStyle.paddingRight || 0);
    if (!containerWidth) return;

    var fvs = buildFVS();

    measurer.style.fontFamily            = "'" + state.font + "', sans-serif";
    measurer.style.fontVariationSettings = fvs;
    measurer.style.fontSize              = REF_SIZE + 'px';
    measurer.style.textTransform        = state.uppercase ? 'uppercase' : 'none';
    measurer.textContent                 = text;

    var textWidth = measurer.offsetWidth;
    if (!textWidth) return;

    var newSize = Math.floor((containerWidth / textWidth) * REF_SIZE);
    newSize = Math.max(20, Math.min(newSize, 800));

    textEl.style.fontSize = newSize + 'px';
  }

  // ---- Get current text content ----

  function getText() {
    if (textEl.classList.contains('is-default')) return PLACEHOLDER;
    return textEl.textContent.trim() || PLACEHOLDER;
  }

  // ---- Render ----

  function render() {
    textEl.style.fontFamily            = "'" + state.font + "', sans-serif";
    textEl.style.fontVariationSettings = buildFVS();
    textEl.style.textTransform         = state.uppercase ? 'uppercase' : '';
    fitText();
  }

  // ---- Font switch ----

  function switchFont(fontName) {
    if (!CONFIGS[fontName]) return;
    state.font = fontName;
    buildAxes(fontName);
    render();
  }

  // ---- Event bindings ----

  fontSelect.addEventListener('change', function () {
    switchFont(fontSelect.value);
  });

  caseBtn.addEventListener('click', function () {
    state.uppercase = !state.uppercase;
    caseBtn.classList.toggle('active', state.uppercase);
    caseBtn.setAttribute('aria-pressed', String(state.uppercase));
    render();
  });

  // Placeholder: clear on focus, restore on blur if empty
  textEl.addEventListener('focus', function () {
    if (textEl.classList.contains('is-default')) {
      textEl.textContent = '';
      textEl.classList.remove('is-default');
    }
  });

  textEl.addEventListener('blur', function () {
    if (textEl.textContent.trim() === '') {
      textEl.textContent = PLACEHOLDER;
      textEl.classList.add('is-default');
      render();
    }
  });

  // Re-fit on every keystroke
  textEl.addEventListener('input', fitText);

  // Re-fit on resize
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitText, 80);
  });

  // ---- Init ----
  switchFont(DEFAULT_FONT);

})();
